import apolloClient from '@/store/apollo';

import FormGql from '@/store/graphql/mutations/FormEntry.gql';

export default {
    create: (formEntry) =>
        new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: FormGql,
                    variables: { formEntry },
                })
                .then(({ data }) => resolve(data.EX_FRMS_CreateFormEntry))
                .catch((error) => reject(error.message));
        }),
};
